import React from 'react';
const AuditCTAV2 = ({ copy, buildHref }) => {
  if (!copy) return null;
  const href = typeof buildHref === 'function' ? buildHref('/v2/audit') : '/v2/audit';
  return (
    <section className="iv2-audit-cta" data-testid="iv2-audit-cta">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{copy.eyebrow}</p>
        <h2 className="iv2-section-headline">{copy.headline}</h2>
        <p className="iv2-audit-cta-body">{copy.body}</p>
        <a href={href} className="iv2-btn iv2-btn-primary" data-testid="iv2-audit-cta-button">{copy.cta_label}</a>
      </div>
    </section>
  );
};
export default AuditCTAV2;
